import client from '/src/services/client.js';

export default {
    getCompanies : (data) => client.get(`companies`,data),
    getCompaniesWithoutPagination : () => client.get(`companies`),
    getCompany : (id,data) => client.get(`company/${id}`, data),
    addCompany : (data) => client.post(`company`, data),
    updateCompany : (id, formData) => client.put(`company/${id}`, formData),
    deleteCompany : (id) => client.delete(`company/${id}`),

    //getCompaniesAutocomplete : (name) => client.get(`autocomplete/company/name?term=${name}`)
    getCompaniesAutocomplete : (name) => client.get(`companies?name=${name}`)
}